import { Typography } from "@mui/material";

export function Title({ title, ...rest }) {
	return (
		<Typography variant="h6" {...rest}>
			{title}
		</Typography>
	);
}